// Texts of the ingest points screen (docs/design/i18n.md).

import { defineMessages } from '@/shared/i18n'

export const messages = defineMessages({
  ru: {
    title: 'Точки приёма',
    issuePoint: 'Выдать точку',
    hint:
      'Точка приёма — временный вход для гостя или корреспондента: свой адрес и пароль на ограниченный срок, отдельно от постоянных входов канала. Доступ больше не нужен — отзовите точку, сессия оборвётся сразу.',
    newPoint: 'Новая точка приёма',
    fieldChannel: 'Канал',
    fieldLabel: 'Подпись',
    fieldLabelHint: 'Кому выдана: «корреспондент, Брюссель».',
    fieldStreamIdHint: 'Ключ поиска на общем порту; не секрет.',
    fieldPassphraseHint: 'Пусто — пульт придумает сам и покажет один раз.',
    fieldStreamId: 'Ключ потока (streamid)',
    fieldPassphrase: 'Пароль',
    colStreamId: 'Ключ потока',
    withPassword: 'с паролем',
    fieldPriority: 'Приоритет',
    fieldNotBefore: 'Действует с',
    fieldNotBeforeHint: 'Пусто — сразу. {zone}.',
    fieldExpiresAt: 'Действует до',
    fieldOnExpire: 'По истечении срока',
    localZone: 'местное время ({offset})',
    utcPreview: 'в UTC: {time}',
    cancel: 'Отмена',
    issue: 'Выдать',
    colWho: 'Кому',
    colChannel: 'Канал',
    colPriority: 'Приоритет',
    colValidity: 'Срок',
    colState: 'Состояние',
    colActions: 'Действия',
    priorityPrimary: 'основной',
    priorityBackup: 'резервный',
    revoke: 'Отозвать',
    delete: 'Удалить',
    empty: 'Точек приёма нет.',
    howItWorks: 'Как это работает →',
    loading: 'Загрузка…',
    issuedTitle: 'Точка выдана',
    issuedConfirm: 'Я передал пароль',
    issuedLead: 'Передайте корреспонденту адрес и пароль.',
    issuedOnce: 'Пароль показывается один раз',
    // Д14 (UIX-прогон 26.09): "пароль" - он, не она.
    issuedTail: ': потом его сможет раскрыть только инженер, и это попадёт в журнал.',
    address: 'Адрес',
    copied: 'Скопировано',
    copyPassphrase: 'Скопировать пароль',
    revokeTitle: 'Отозвать точку?',
    deleteTitle: 'Удалить точку?',
    revokeBody: 'Точка «{name}» перестанет принимать подключения, идущая сессия разорвётся сразу.',
    deleteBody: 'Точка «{name}» будет удалена.',

    // model.ts
    priorityPrimaryLong: 'основной (вытесняет постоянный вход)',
    priorityBackupLong: 'резервный (только если основного нет)',
    onExpireKeep: 'не рвать идущую сессию',
    onExpireKick: 'разорвать сессию',
    errChannel: 'выберите канал',
    errExpiresMissing: 'укажите, до какого времени точка принимает подключения',
    errExpiresPast: 'срок уже прошёл',
    errBadDate: 'непонятная дата',
    errStartAfterEnd: 'начало должно быть раньше окончания',
    stateRevoked: 'отозвана',
    stateExpired: 'срок истёк',
    statePending: 'ещё не началась',
    stateActive: 'принимает',
  },
  en: {
    title: 'Ingest points',
    issuePoint: 'Issue ingest point',
    hint:
      'An ingest point is a temporary input for a guest or a contributor: its own address and password for a limited time, separate from the permanent inputs of the channel. No longer needed? Revoke the point and the session drops at once.',
    newPoint: 'New ingest point',
    fieldChannel: 'Channel',
    fieldLabel: 'Label',
    fieldLabelHint: 'Who it is for: “contributor, Brussels”.',
    fieldStreamIdHint: 'Lookup key on the shared port; not a secret.',
    fieldPassphraseHint: 'Empty: the console generates one and shows it once.',
    fieldStreamId: 'Stream key (streamid)',
    fieldPassphrase: 'Password',
    colStreamId: 'Stream key',
    withPassword: 'with password',
    fieldPriority: 'Priority',
    fieldNotBefore: 'Valid from',
    fieldNotBeforeHint: 'Empty: right away. {zone}.',
    fieldExpiresAt: 'Valid until',
    fieldOnExpire: 'On expiry',
    localZone: 'local time ({offset})',
    utcPreview: 'in UTC: {time}',
    cancel: 'Cancel',
    issue: 'Issue',
    colWho: 'For',
    colChannel: 'Channel',
    colPriority: 'Priority',
    colValidity: 'Validity',
    colState: 'State',
    colActions: 'Actions',
    priorityPrimary: 'primary',
    priorityBackup: 'backup',
    revoke: 'Revoke',
    delete: 'Delete',
    empty: 'No ingest points.',
    howItWorks: 'How it works →',
    loading: 'Loading…',
    issuedTitle: 'Ingest point issued',
    issuedConfirm: 'I have passed on the password',
    issuedLead: 'Give the contributor the address and the password.',
    issuedOnce: 'The password is shown only once',
    issuedTail: ': after that only an engineer can reveal it, and that goes into the audit log.',
    address: 'Address',
    copied: 'Copied',
    copyPassphrase: 'Copy password',
    revokeTitle: 'Revoke the ingest point?',
    deleteTitle: 'Delete the ingest point?',
    revokeBody: 'Ingest point “{name}” will stop accepting connections; the live session drops at once.',
    deleteBody: 'Ingest point “{name}” will be deleted.',

    priorityPrimaryLong: 'primary (takes over the permanent input)',
    priorityBackupLong: 'backup (only when there is no primary)',
    onExpireKeep: 'keep the live session',
    onExpireKick: 'drop the session',
    errChannel: 'choose a channel',
    errExpiresMissing: 'set the time until which the point accepts connections',
    errExpiresPast: 'this time has already passed',
    errBadDate: 'not a valid date',
    errStartAfterEnd: 'the start must be before the end',
    stateRevoked: 'revoked',
    stateExpired: 'expired',
    statePending: 'not started yet',
    stateActive: 'accepting',
  },
})
